import { CalendarHeart } from 'lucide-react';
import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/Card';
const SubscribersActivity = ({ subscriberActivity }) => {
    return (
        <Card className="shadow-elegant">
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    <CalendarHeart className="h-5 w-5 text-primary" />
                    Abone Aktivite Takvimi
                </CardTitle>
                <CardDescription>Üyelerinizin tarihsel kayıt durumu</CardDescription>
            </CardHeader>
            <CardContent>

                <div className="grid grid-cols-3 gap-3 text-center text-sm">
                    {subscriberActivity.map((day, idx) => (
                        <div
                            key={day.date + idx}
                            className="rounded-lg bg-blue-50 p-3 flex flex-col items-center justify-center"
                        >
                            <span className="font-semibold text-blue-600">{day.count}</span>
                            <span className="text-xs text-gray-500">
                                {new Date(day.date).toLocaleDateString("tr-TR", {
                                    day: "numeric",
                                    month: "short",
                                    year: "numeric",
                                })}
                            </span>
                        </div>
                    ))}

                </div>
            </CardContent>
        </Card>
    )
}

export default SubscribersActivity;